<mat-card appearance="outlined" fxFlex="auto" fxLayout="column" fxLayoutAlign="space-between start" layout-padding>

    <mat-card-content [formGroup]="alertForm" fxLayout="column" fxLayoutAlign="space-between stretch">

        <div *ngIf="isExpired" class="error-text fs-2x">EXPIRED</div>

        <div fxLayout="row" fxLayoutAlign="space-between start">

            <lgd-select fxFlex="20" controlName="code" label="Alert Code" placeholder="Select a code" [options]="alertCodesObservable">
            </lgd-select>

            <lgd-date-picker fxFlex="30" controlName="expirationDateAndTime" label="Expiration Date">
            </lgd-date-picker>

            <!-- TODO - This could just be a label and value, why was it a control? -->
            <lgd-text fxFlex="20" controlName="createdBy" label="Created By">
            </lgd-text>

            <!-- TODO - This could just be a label and value, why was it a control? -->
            <lgd-date-picker fxFlex="30" controlName="createdDate" label="Created On">
            </lgd-date-picker>
        </div>

        <div fxFlexFill fxLayout="row" fxLayoutAlign="space-between center">
            <lgd-textarea controlName="message" label="Message">
            </lgd-textarea>

            <command command="deleteCommand" class="mb20" telemetry="Menu-Alerts"></command>
            
        </div>
    </mat-card-content>
</mat-card>